(() => {
  if (window.KamokEta) {
    window.KamokEta.refresh(document);
    return;
  }

  const DAY = { SUN: 0, MON: 1, TUE: 2, WED: 3, THU: 4, FRI: 5, SAT: 6 };

  function vilniusNow() {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Vilnius',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date());
    const get = (type) => Number(parts.find((p) => p.type === type)?.value || 0);
    return {
      date: new Date(Date.UTC(get('year'), get('month') - 1, get('day'))),
      hour: get('hour'),
      minute: get('minute')
    };
  }

  function addCalendarDays(date, days) {
    const d = new Date(date.getTime());
    d.setUTCDate(d.getUTCDate() + days);
    return d;
  }

  function addBusinessDays(date, days) {
    let d = new Date(date.getTime());
    let left = Math.max(0, Number(days) || 0);
    while (left > 0) {
      d = addCalendarDays(d, 1);
      const dow = d.getUTCDay();
      if (dow !== 0 && dow !== 6) left -= 1;
    }
    return d;
  }

  function parseWeekdays(value) {
    return String(value || '')
      .split(',')
      .map((v) => DAY[v.trim().toUpperCase()])
      .filter((v) => Number.isInteger(v));
  }

  function nextOrderDate(baseDate, hour, minute, cutoffHour, weekdays) {
    for (let i = 0; i < 15; i += 1) {
      const d = addCalendarDays(baseDate, i);
      if (!weekdays.includes(d.getUTCDay())) continue;
      const beforeCutoff = hour < cutoffHour || (hour === cutoffHour && minute === 0);
      if (i > 0 || beforeCutoff) return d;
    }
    return null;
  }

  function nextAllowedDateAfter(baseDate, weekdays) {
    for (let i = 1; i < 15; i += 1) {
      const d = addCalendarDays(baseDate, i);
      if (weekdays.includes(d.getUTCDay())) return d;
    }
    return null;
  }

  function formatLtDate(date) {
    return new Intl.DateTimeFormat('lt-LT', {
      timeZone: 'UTC', day: 'numeric', month: 'long'
    }).format(date);
  }

  function setValue(el, text) {
    const target = el.querySelector('[data-kamok-eta-value]');
    if (target) target.textContent = text;
  }

  function calculate(el) {
    const country = (el.dataset.country || 'LT').toUpperCase();
    if (country !== 'LT') {
      setValue(el, 'Terminas kitoms šalims patikslinamas atsiskaitymo metu');
      return;
    }

    const status = el.dataset.status || 'unknown';
    const rule = el.dataset.rule || '';
    const isCalculatedStatus = status === 'verified' || status === 'estimated';
    if (!isCalculatedStatus) {
      setValue(el, 'Pristatymo terminas tikslinamas');
      return;
    }

    if (rule === 'lead_time') {
      const now = vilniusNow();
      const min = Number(el.dataset.supplierMin || 0) + Number(el.dataset.dispatchDelay || 0) + Number(el.dataset.lastMileMin || 0);
      const max = Number(el.dataset.supplierMax || 0) + Number(el.dataset.dispatchDelay || 0) + Number(el.dataset.lastMileMax || 0);
      if (min > 0 && max >= min) {
        const etaMin = addBusinessDays(now.date, min);
        const etaMax = addBusinessDays(now.date, max);
        setValue(el, `Preliminariai: ${formatLtDate(etaMin)} – ${formatLtDate(etaMax)} (${min}–${max} d. d.)`);
      } else {
        setValue(el, 'Pristatymo terminas tikslinamas');
      }
      return;
    }

    if (rule === 'scheduled') {
      const now = vilniusNow();
      const cutoff = Number(el.dataset.cutoffHour || 12);
      const orderDays = parseWeekdays(el.dataset.orderWeekdays);
      const arrivalDays = parseWeekdays(el.dataset.arrivalWeekdays);
      if (!orderDays.length || !arrivalDays.length) {
        setValue(el, 'Pristatymo terminas tikslinamas');
        return;
      }
      const orderDate = nextOrderDate(now.date, now.hour, now.minute, cutoff, orderDays);
      const arrivalDate = orderDate && nextAllowedDateAfter(orderDate, arrivalDays);
      if (!arrivalDate) {
        setValue(el, 'Pristatymo terminas tikslinamas');
        return;
      }
      const dispatchDate = addBusinessDays(arrivalDate, Number(el.dataset.dispatchDelay || 0));
      const etaMin = addBusinessDays(dispatchDate, Number(el.dataset.lastMileMin || 1));
      const etaMax = addBusinessDays(dispatchDate, Number(el.dataset.lastMileMax || 2));
      setValue(el, `Preliminariai: ${formatLtDate(etaMin)} – ${formatLtDate(etaMax)}`);
      return;
    }

    setValue(el, 'Pristatymo terminas tikslinamas');
  }

  function refresh(root = document) {
    const elements = root.matches?.('[data-kamok-eta]')
      ? [root]
      : Array.from(root.querySelectorAll?.('[data-kamok-eta]') || []);
    elements.forEach(calculate);
  }

  window.KamokEta = { refresh };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => refresh(document), { once: true });
  } else {
    refresh(document);
  }
})();
